module.exports = __webpack_public_path__ + "img/6.98cbe7.png";